import React, { useEffect, useState } from "react";
import { database } from "./firebase";
import { ref, get } from "firebase/database";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import sfRoundedBold from "../assets/fonts/SF-Pro-Rounded-Bold.otf";
import sfRoundedMedium from "../assets/fonts/SF-Pro-Rounded-Medium.otf";
import sfRoundedLight from "../assets/fonts/SF-Pro-Rounded-Light.otf";
import moodIcon from "../assets/moodstream-icon.png";

const ACCENT = "#f700ff";
const BG_TOP = "#05050b";
const BG_BOTTOM = "#1c0930";
const PAGE_BG = `linear-gradient(180deg, ${BG_TOP} 0%, ${BG_BOTTOM} 100%)`;

export default function SingleAlbum() {
  const params = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [username, setusername] = useState(null);
  const [todisplaygallerys, settodisplaygallerys] = useState(null);
  const [fontsReady, setFontsReady] = useState(false);

  useEffect(() => {
    document.fonts.ready.then(() => setFontsReady(true));
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const prev = {
      htmlBg: html.style.background, htmlBgColor: html.style.backgroundColor, htmlMinH: html.style.minHeight,
      bodyBg: body.style.background, bodyBgColor: body.style.backgroundColor, bodyMinH: body.style.minHeight,
      rootBg: root?.style.background ?? "",
    };
    html.style.background = PAGE_BG;
    html.style.backgroundColor = BG_BOTTOM;
    html.style.minHeight = "100%";
    body.style.background = PAGE_BG;
    body.style.backgroundColor = BG_BOTTOM;
    body.style.minHeight = "100%";
    if (root) { root.style.minHeight = "100%"; root.style.background = "transparent"; }
    return () => {
      html.style.background = prev.htmlBg; html.style.backgroundColor = prev.htmlBgColor; html.style.minHeight = prev.htmlMinH;
      body.style.background = prev.bodyBg; body.style.backgroundColor = prev.bodyBgColor; body.style.minHeight = prev.bodyMinH;
      if (root) root.style.background = prev.rootBg;
    };
  }, []);

  useEffect(() => {
    console.log("this is the state", state);
    const dum = get(ref(database, "posts/" + state.galId));
    dum.then((res) => {
      settodisplaygallerys(
        Object.values(res.val()).sort((a, b) => b.timestamp - a.timestamp)
      );
    });
    setusername(state.username);
  }, []);

  const galleryTitle = state?.ent?.public?.galleryInfo?.name ?? "";

  return (
    <>
      <style>{`
        @font-face {
          font-family: 'SF Pro Rounded Bold';
          src: url(${sfRoundedBold}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }
        @font-face {
          font-family: 'SF Pro Rounded Medium';
          src: url(${sfRoundedMedium}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }
        @font-face {
          font-family: 'SF Pro Rounded Light';
          src: url(${sfRoundedLight}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }

        @keyframes sa-spin { to { transform: rotate(360deg); } }

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .sa-page {
          min-height: 100vh;
          min-height: 100dvh;
          background: ${PAGE_BG};
          background-color: ${BG_BOTTOM};
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #fff;
          font-family: 'SF Pro Rounded Medium', -apple-system, BlinkMacSystemFont, sans-serif;
          padding-bottom: 140px;
        }

        /* ── Sticky topbar ── */
        .sa-topbar {
          position: sticky;
          top: 0;
          z-index: 100;
          align-self: stretch;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 20px 12px;
          background: rgba(8, 0, 15, 0.8);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(247, 0, 255, 0.12);
        }
        .sa-back {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          margin-right: 2px;
          color: rgba(255,255,255,0.75);
          font-size: 26px;
          line-height: 1;
          flex-shrink: 0;
          display: flex;
          align-items: center;
        }
        .sa-topbar-icon {
          width: 34px;
          height: 34px;
          border-radius: 9px;
          object-fit: cover;
          flex-shrink: 0;
        }
        .sa-topbar-title {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 16px;
          font-weight: normal;
          color: rgba(255,255,255,0.75);
        }

        /* ── Centered content column ── */
        .sa-inner {
          width: 100%;
          max-width: 420px;
          display: flex;
          flex-direction: column;
          padding: 28px 12px 0;
        }

        .sa-title {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 30px;
          font-weight: normal;
          color: #fff;
          line-height: 1.2;
          letter-spacing: -0.02em;
          word-break: break-word;
          overflow-wrap: break-word;
          margin-bottom: 20px;
          text-align: center;
        }

        /* ── Posts ── */
        .sa-posts {
          display: flex;
          flex-direction: column;
          gap: 30px;
          align-items: center;
        }
        .sa-post {
          width: 85%;
          border-radius: 30px;
          overflow: hidden;
          background: #160025;
        }
        .sa-post img {
          width: 100%;
          display: block;
          object-fit: cover;
          opacity: 0;
          transition: opacity 0.18s ease-out;
        }
        .sa-post img.loaded { opacity: 1; }

        .sa-posts-loading {
          display: flex;
          justify-content: center;
          padding: 48px 0;
        }

        /* ── Sticky footer ── */
        .sa-footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(8, 0, 15, 0.88);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-top: 1px solid rgba(247, 0, 255, 0.15);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 18px;
          padding: 12px 24px 22px;
        }
        .sa-footer-label {
          font-family: 'SF Pro Rounded Medium', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 17px;
          color: rgba(255,255,255,0.7);
          line-height: 1.35;
          text-align: center;
          white-space: normal;
        }
        .sa-footer-label strong {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          color: #fff;
          font-weight: normal;
        }
        .sa-cta {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          max-width: 235px;
          padding: 16px 14px;
          border: none;
          border-radius: 999px;
          background: ${ACCENT};
          color: #fff;
          font-size: 16px;
          font-weight: normal;
          cursor: pointer;
          text-decoration: none;
          transition: filter 0.2s ease, transform 0.15s ease;
        }
        .sa-cta:hover { filter: brightness(1.1); transform: translateY(-1px); }
        .sa-cta-arrow { font-size: 1.1em; line-height: 1; }
      `}</style>

      <div className="sa-page">
        {!fontsReady ? (
          <div style={{ minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{
              width: 40, height: 40,
              border: `3px solid rgba(247, 0, 255, 0.2)`,
              borderTop: `3px solid ${ACCENT}`,
              borderRadius: "50%",
              animation: "sa-spin 0.9s linear infinite",
            }} />
          </div>
        ) : (
          <>
            <div className="sa-topbar">
              <button
                className="sa-back"
                onClick={() => navigate("/" + username)}
                aria-label="Back"
              >
                ‹
              </button>
              <img src={moodIcon} alt="MoodStream" className="sa-topbar-icon" />
              <span className="sa-topbar-title">moodstream.me/{username}</span>
            </div>

            <div className="sa-inner">
              {galleryTitle ? <h1 className="sa-title">{galleryTitle}</h1> : null}

              <div className="sa-posts">
                {todisplaygallerys === null ? (
                  <div className="sa-posts-loading">
                    <div style={{
                      width: 32, height: 32,
                      border: `3px solid rgba(247, 0, 255, 0.2)`,
                      borderTop: `3px solid ${ACCENT}`,
                      borderRadius: "50%",
                      animation: "sa-spin 0.9s linear infinite",
                    }} />
                  </div>
                ) : (
                  todisplaygallerys.map((ent, index) =>
                    ent?.imgURL ? (
                      <div className="sa-post" key={index}>
                        <img
                          src={ent.imgURL}
                          alt={`Post ${index + 1}`}
                          onLoad={(e) => e.target.classList.add("loaded")}
                          onError={(e) => { e.target.style.display = "none"; }}
                        />
                      </div>
                    ) : null
                  )
                )}
              </div>
            </div>

            {state?.link && (
              <div className="sa-footer">
                <p className="sa-footer-label">
                  View <strong>{galleryTitle}</strong> on MoodStream
                </p>
                <button
                  className="sa-cta"
                  onClick={() => { window.location.href = state.link; }}
                >
                  Open MoodStream
                  <span className="sa-cta-arrow">→</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
